'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = function () {

    var scrollTopElement = [].concat((0, _toConsumableArray3.default)(document.getElementsByClassName('scrollTopElement'))).shift();
    if (!scrollTopElement) return;

    scrollTopElement.addEventListener('click', scroll);

    function scroll() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    };
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/scrollTop.js
// module id = 947
// module chunks = 0